export default __webpack_public_path__ + "static/media/pago_seguro.63036d3f.png";